import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  DialogContentText
} from "@material-ui/core";

import { closeContributorModal } from "../../actions/modalActions";

import "../../styles/processModal.scss";

class ContributorModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleClose = () => {
    if (new Date() - this.props.modalOpenTime > 1000) {
      this.props.closeContributorModal();
    }
  };

  render() {
    const actions = [
      <Button color="secondary" onClick={this.handleClose}>
        Close
      </Button>
    ];

    return (
      <Dialog
        open={this.props.isOpen}
        onClose={this.handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Credits</DialogTitle>
        <DialogContent>
          <DialogContentText>
            The original idea for this periodic table with ALD-prepared
            materials came from <b>Riikka Puurunen</b> [J. Appl. Phys. 97,
            121301 (2005)] and it was updated by <b>Ville Miikkulainen</b>,{" "}
            <b>Markku Leskelä</b>, <b>Mikko Ritala</b>, and{" "}
            <b>Riikka Puurunen</b> in their review paper that appeared a few
            years later [J. Appl. Phys. 113, 021301 (2013)].
            <br /> <br />
            Other major additions were based on the reviews by{" "}
            <b>Harm Knoops</b>, <b>Tahsin Faraz</b>, <b>Karsten Arts</b> and{" "}
            <b>Erwin Kessels</b> [J. Vac. Sci. Technol. A 37, 030902 (2019)] and
            by <b>Adrie Mackus</b>, <b>Joel Schneider</b>,{" "}
            <b>Callisto MacIsaac</b>, <b>Jon Baker</b> and <b>Stacey Bent</b>{" "}
            [Chem. Mater. 31, 1142 (2019)].
            <br /> <br />
            The initiative for this online database was taken by{" "}
            <b>Harm Knoops</b>, <b>Bart Macco</b>, <b>Vincent Vandalon</b> and{" "}
            <b>Erwin Kessels</b>. The new submissions and comments will be reviewed
            by <b>Joseph P. Klesko</b>, <b>Harm Knoops</b>, <b>Bart Macco</b>, and <b>Vincent Vandalon</b>{" "}
            aiming for a weekly update of the database.{" "}
            <b>Erwin Kessels</b> is responsible for the overall management. 
            Queries and questions can be submitted to <a href="mailto:info@atomiclimits.com">info@atomiclimits.com</a>
            <br /> <br />
            <b>Jan Buiter</b> designed the website and took care of the
            programming.
            <br /> <br />
            In addition to the people above, we would like to thank the
            following persons for contributing significantly to the contents of
            this database: (Your name can appear here if you add materials,
            processes or references (See “About this periodic table” and “Add
            process” button in the menu.))
            <br />
            <br />
            {this.props.contributors
              .filter(
                contributor =>
                  ![
                    "",
                    "Jan Buiter",
                    "Harm Knoops",
                    "Bart Macco",
                    "Vincent Vandalon",
                    "Adrie Mackus"
                  ].includes(contributor.name)
              )
              .map(contributor => (
                <>
                  <b>{contributor.name}</b>: {contributor.number}{" "}
                  {contributor.number > 1 ? "contributions" : "contribution"}
                  <br />
                </>
              ))}
          </DialogContentText>
        </DialogContent>
        <DialogActions>{actions}</DialogActions>
      </Dialog>
    );
  }
}

function mapStateToProps(state) {
  return {
    isOpen: state.modal.contributorModalIsOpen,
    contributors: state.process.contributors,
    modalOpenTime: state.modal.modalOpenTime
  };
}

export default connect(
  mapStateToProps,
  { closeContributorModal }
)(ContributorModal);
